import styled from 'styled-components';
import SelectedLocationMarkerIcon from '#/shared/components/GeneratedIcons/trimet/SelectedLocationMarker';
import {
  ClearButton,
  TripButton as BaseTripButton,
} from '#/shared/components/Styled';

import { GTM_DATA_ATTRIBUTE } from '#/shared/constants';

export const TripButton = styled(BaseTripButton).attrs(props => ({
  [GTM_DATA_ATTRIBUTE]: props.dataGtm,
}))``;

export const ZoomToLocationButton = styled(ClearButton).attrs(props => ({
  [GTM_DATA_ATTRIBUTE]: props.dataGtm,
}))`
  right: 1em;
  margin: 2px 4px;
  background-color: transparent;
  border-radius: 5px;
  border: 1px solid ${props => props.theme.inverseFontColor1};
  color: ${props => props.theme.secondaryBackgroundColor};
  padding: 6px 10px;
  @media (any-hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.inverseButtonColor2};
    }
  }
  &:focus,
  &:active {
    background-color: ${props => props.theme.actionColor};
    outline: 0;
  }

  &:focus-visible {
    outline: 2px solid ${props => props.theme.focusVisible};
  }
  &:hover {
    background-color: ${props => props.theme.inverseButtonColor1} !important;
  }
`;

export const LocationIconSolid = styled(SelectedLocationMarkerIcon).attrs({
  width: '80%',
  height: '80%',
  title: 'Location',
})`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
